import { Box } from '@mui/material';
import { memo, useContext, useState } from 'react';

import { CLIENT_STATUS } from '../../../../../common/client-status/interfaces';
import { ClientStatusContext } from '../../../../../common/client-status';
import { nortadaStorage } from '../../../../../../constants/helpers/storage';
import { ClientSecretsForm } from '../../../../../common/client-secrets/clientSecretsForm';
import { AlertAfterSuccefullyGetSecrets } from '../../../../../common/common-alert-messages';
import { NORTADA_CLIENT_ID, NORTADA_CLIENT_SECRET } from '../../../../../../constants/storage';

const SaveSecrets = () => {
  const { getClientStatus } = useContext(ClientStatusContext);
  const [saved, setSaved] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const handleSubmit = () => {
    setIsLoading(true);
    getClientStatus({
      onSuccess: (status: CLIENT_STATUS) => {
        if (status !== 'CLIENT_PROFILE_ACTIVE' && status !== 'CLIENT_PROFILE_BLOCKED') {
          setIsError(true);
          setIsLoading(false);
        }
      },
      onFailure: () => {
        setIsError(true);
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Box mb={2}>
        <AlertAfterSuccefullyGetSecrets />
      </Box>
      <ClientSecretsForm
        clientId={nortadaStorage.getItem(NORTADA_CLIENT_ID) || ''}
        clientSecret={nortadaStorage.getItem(NORTADA_CLIENT_SECRET) || ''}
        clientIdAndSecretSaved={saved}
        toggleClientIdAndSecretSaved={() => {
          setSaved(!saved);
        }}
        handleSubmit={handleSubmit}
        submitText="Proceed to the Developer Portal"
        isSubmitLoading={isLoading}
        isError={isError}
      />
    </>
  );
};

export default memo(SaveSecrets);
